export const API_DELETE_OFFER = 'CANCEL_OFFER' as const;
export const API_DELETE_OFFER_REQUEST = 'CANCEL_OFFER_REQUEST' as const;
export const API_DELETE_OFFER_SUCCESS = 'CANCEL_OFFER_SUCCESS' as const;
export const API_DELETE_OFFER_FAILURE = 'CANCEL_OFFER_FAILURE' as const;

export const API_READ_EXISTING_OFFER = 'GET_EXISTING_OFFER' as const;
export const API_READ_EXISTING_OFFER_REQUEST = 'GET_EXISTING_OFFER_REQUEST' as const;
export const API_READ_EXISTING_OFFER_SUCCESS = 'GET_EXISTING_OFFER_SUCCESS' as const;
export const API_READ_EXISTING_OFFER_FAILURE = 'GET_EXISTING_OFFER_FAILURE' as const;

export const API_READ_ACTIVE_OFFER_CAMPAIGNS = 'GET_ACTIVE_OFFER_CAMPAIGNS' as const;
export const API_READ_ACTIVE_OFFER_CAMPAIGNS_REQUEST = 'GET_ACTIVE_OFFER_CAMPAIGNS_REQUEST' as const;
export const API_READ_ACTIVE_OFFER_CAMPAIGNS_SUCCESS = 'GET_ACTIVE_OFFER_CAMPAIGNS_SUCCESS' as const;
export const API_READ_ACTIVE_OFFER_CAMPAIGNS_FAILURE = 'GET_ACTIVE_OFFER_CAMPAIGNS_FAILURE' as const;

export const API_READ_OFFER_CAMPAIGN_REDEMPTIONS = 'GET_OFFER_CAMPAIGN_REDEMPTIONS' as const;
export const API_READ_OFFER_CAMPAIGN_REDEMPTIONS_REQUEST = 'GET_OFFER_CAMPAIGN_REDEMPTIONS_REQUEST' as const;
export const API_READ_OFFER_CAMPAIGN_REDEMPTIONS_SUCCESS = 'GET_OFFER_CAMPAIGN_REDEMPTIONS_SUCCESS' as const;
export const API_READ_OFFER_CAMPAIGN_REDEMPTIONS_FAILURE = 'GET_OFFER_CAMPAIGN_REDEMPTIONS_FAILURE' as const;

export const API_READ_OFFER_CAMPAIGN_ORDERS = 'GET_OFFER_CAMPAIGN_ORDERS' as const;
export const API_READ_OFFER_CAMPAIGN_ORDERS_REQUEST = 'GET_OFFER_CAMPAIGN_ORDERS_REQUEST' as const;
export const API_READ_OFFER_CAMPAIGN_ORDERS_SUCCESS = 'GET_OFFER_CAMPAIGN_ORDERS_SUCCESS' as const;
export const API_READ_OFFER_CAMPAIGN_ORDERS_FAILURE = 'GET_OFFER_CAMPAIGN_ORDERS_FAILURE' as const;

export const API_READ_OFFER_INVENTORY = 'GET_OFFER_INVENTORY' as const;
export const API_READ_OFFER_INVENTORY_REQUEST = 'GET_OFFER_INVENTORY_REQUEST' as const;
export const API_READ_OFFER_INVENTORY_SUCCESS = 'GET_OFFER_INVENTORY_SUCCESS' as const;
export const API_READ_OFFER_INVENTORY_FAILURE = 'GET_OFFER_INVENTORY_FAILURE' as const;

export const API_READ_OFFER_CONFIG = 'GET_OFFERS_CONFIG' as const;
export const API_READ_OFFER_CONFIG_REQUEST = 'GET_OFFERS_CONFIG_REQUEST' as const;
export const API_READ_OFFER_CONFIG_SUCCESS = 'GET_OFFERS_CONFIG_SUCCESS' as const;
export const API_READ_OFFER_CONFIG_FAILURE = 'GET_OFFERS_CONFIG_FAILURE' as const;

export const API_READ_OFFERS = 'GET_EXISTING_OFFERS' as const;
export const API_READ_OFFERS_REQUEST = 'GET_EXISTING_OFFERS_REQUEST' as const;
export const API_READ_OFFERS_SUCCESS = 'GET_EXISTING_OFFERS_SUCCESS' as const;
export const API_READ_OFFERS_FAILURE = 'GET_EXISTING_OFFERS_FAILURE' as const;

export const API_READ_PAGINATED_OFFERS = 'GET_PAGINATED_OFFERS' as const;
export const API_READ_PAGINATED_OFFERS_REQUEST = 'GET_PAGINATED_OFFERS_REQUEST' as const;
export const API_READ_PAGINATED_OFFERS_SUCCESS = 'GET_PAGINATED_OFFERS_SUCCESS' as const;
export const API_READ_PAGINATED_OFFERS_FAILURE = 'GET_PAGINATED_OFFERS_FAILURE' as const;

export const API_SAVE_OFFER = 'CREATE_NEW_OFFER' as const;
export const API_SAVE_OFFER_REQUEST = 'CREATE_NEW_OFFER_REQUEST' as const;
export const API_SAVE_OFFER_SUCCESS = 'CREATE_NEW_OFFER_SUCCESS' as const;
export const API_SAVE_OFFER_FAILURE = 'CREATE_NEW_OFFER_FAILURE' as const;

export const SET_OFFER_DAYS_OF_WEEK = 'SET_OFFER_DAYS_OF_WEEK' as const;
export const SET_OFFER_ITEMS = 'SET_OFFER_ITEMS' as const;
export const SET_OFFER_TYPE = 'SET_OFFER_TYPE' as const;
export const SET_OFFER_DISCOUNT = 'SET_OFFER_DISCOUNT' as const;
export const SET_OFFER_FULFILLMENT_METHODS = 'SET_OFFER_FULFILLMENT_METHODS' as const;
export const SET_OFFER_END_DATE = 'SET_OFFER_END_DATE' as const;
export const SET_OFFER_END_TIME = 'SET_OFFER_END_TIME' as const;
export const SET_OFFER_GOAL = 'SET_OFFER_GOAL' as const;
export const SET_OFFER_MOV = 'SET_OFFER_MOV' as const;
export const SET_OFFER_ORG_ID = 'SET_OFFER_ORG_ID' as const;
export const SET_OFFER_SCHEDULE_TYPE = 'SET_OFFER_SCHEDULE_TYPE' as const;
export const SET_OFFER_SELECTED_RESTAURANTS = 'SET_OFFER_SELECTED_RESTAURANTS' as const;
export const SET_OFFER_START_DATE = 'SET_OFFER_START_DATE' as const;
export const SET_OFFER_START_TIME = 'SET_OFFER_START_TIME' as const;
export const SET_OFFER_THEME = 'SET_OFFER_THEME' as const;
export const SET_OFFER_TIME_OF_DAY_FROM = 'SET_OFFER_TIME_OF_DAY_FROM' as const;
export const SET_OFFER_TIME_OF_DAY_UNTIL = 'SET_OFFER_TIME_OF_DAY_UNTIL' as const;
export const SET_OFFER_TIMEZONE = 'SET_OFFER_TIMEZONE' as const;
export const CLEAR_NEW_OFFER = 'CLEAR_NEW_OFFER' as const;
export const CLEAR_EXISTING_OFFER = 'CLEAR_EXISTING_OFFER' as const;
export const VALIDATE_OFFER = 'VALIDATE_OFFER' as const;
